import { telanganaDistrictKeyFromStored } from "../data/telanganaDistricts";
import { normalizeGeoLabel } from "./geoLabel";
import type { Application, GeoZone } from "../types";

/** True if the application’s district / mandal / village falls under the zone rules. */
export function applicationMatchesGeoZone(app: Application, zone: GeoZone): boolean {
  const appDk = telanganaDistrictKeyFromStored(app.district);
  if (appDk && zone.districtKeys.includes(appDk)) return true;
  const m = normalizeGeoLabel(app.mandal);
  const v = normalizeGeoLabel(app.village);
  if (
    zone.mandalRefs.some((r) => {
      const refDk = telanganaDistrictKeyFromStored(r.district);
      return refDk === appDk && normalizeGeoLabel(r.mandalName) === m;
    })
  ) {
    return true;
  }
  return zone.villageRefs.some((r) => {
    const refDk = telanganaDistrictKeyFromStored(r.district);
    return refDk === appDk && normalizeGeoLabel(r.mandalName) === m && normalizeGeoLabel(r.villageName) === v;
  });
}

export function mandalRefKey(district: string, mandalName: string): string {
  return `${district}|${normalizeGeoLabel(mandalName)}`;
}

export function villageRefKey(district: string, mandalName: string, villageName: string): string {
  return `${district}|${normalizeGeoLabel(mandalName)}|${normalizeGeoLabel(villageName)}`;
}
